<div class="delete-container">
  <p *ngIf="stepOne">
    Se eliminará la reserva y todas sus estadísticas asociadas. ¿Desea
    continuar?
  </p>
  <p *ngIf="stepTwo">
    {{ message }}
  </p>
</div>
<div class="overlay-footer" *ngIf="!hasSignal">
  <qr-button [config]="buttonCancel" (click)="closeOverlay()"></qr-button>
  <qr-button
    [config]="buttonDelete"
    (click)="confirm()"
    *ngIf="!deleteSuccesfull"
  ></qr-button>
</div>
<div class="overlay-footer" *ngIf="hasSignal">
  <qr-button [config]="buttonNo" (click)="closeOverlay()"></qr-button>
  <qr-button [config]="buttonYes" (click)="confirmProcess()"></qr-button>
</div>
